import * as React from 'react';
import { INode } from '@mrblenny/react-flow-chart';
import { NodeType } from './enums';
import { numberWithCommas, numberWithPercent } from '../../_utils/utils';
import { AreaChartOutlined, TeamOutlined } from '@ant-design/icons';

interface INodeInnerStats {
    node: INode,
    stats: any,
}

export class NodeInnerStats extends React.PureComponent<INodeInnerStats> {
    public render() {
        return this.renderStyle1();
    }

    protected renderStyle1() {
        const { node, stats } = this.props;
        const entrances = stats?.entrances ?? 0;
        const exits = stats?.exits ?? 0;
        const deliveries = stats?.deliveries ?? 0;
        const ctr = stats?.ctr_decimal ?? 0;
        const current = stats?.current ?? 0;

        return (
            <div className="node-stats style-1">
                <div className="node-stats-details">
                    <span className="node-stats-icon">
                        <AreaChartOutlined />
                    </span>
                    <span className="node-stats-figures">
                        {node.type === NodeType.TRIGGER ? (
                            <>
                                <span className="node-stats-entered">
                                    <span className="label">Entered:</span> {numberWithCommas(entrances)}
                                </span>
                            </>
                        ) : node.type === NodeType.CAMPAIGN_EXIT ? (
                            <>
                                <span className="node-stats-entered">
                                    <span className="label">Exited:</span> {numberWithCommas(entrances)}
                                </span>
                            </>
                        ) : node.type === NodeType.ACTION ? (
                            <>
                                <span className="node-stats-sent">
                                    <span className="label">Delivered:</span> {numberWithCommas(deliveries)}
                                </span>
                                <span className="node-stats-ctr">
                                    <span className="label">CTR:</span> {!stats ? 'N/A' : numberWithPercent(ctr)}
                                </span>
                            </>
                        ) : (
                            <>
                                <span className="node-stats-current">
                                    <span className="label">Current:</span> {current < 0 ? 0 : numberWithCommas(current)}
                                </span>
                            </>
                        )}
                    </span>
                </div>
            </div>
        );
    }

    protected renderStyle2() {
        const { node, stats } = this.props;

        return (
            <div className="node-stats style-2">
                <div className="node-stats-details">
                    {!!stats.entrances && (
                        <>
                            <span className="node-stats-icon">
                                <TeamOutlined />
                            </span>
                            <span className="node-stats-entered">
                                {numberWithCommas(stats.entrances)}
                            </span>
                        </>
                    )}
                </div>
            </div>
        );
    }
}
